import { ScrollShadow } from '@heroui/react';
import React, { FC, ReactNode, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { Flex } from '../Flex';
import {
  AppFooter,
  AppWrapper,
} from './Layout.style';
import { Navigation } from './Navigation';

export interface LayoutProps {
  children: ReactNode;
}

export const Layout: FC<LayoutProps> = ({ children }) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const { pathname } = useLocation();

  useEffect(() => {
    scrollRef.current?.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname]);

  return (
    <Flex direction="row" gap="small" fullHeight>
      <ScrollShadow ref={scrollRef} style={{ width: '100%', height: '100dvh' }} size={0}>
        <AppWrapper noPadding={pathname === '/nearby'} style={{ flex: '1 1 auto' }}>
          {children}
        </AppWrapper>
      </ScrollShadow>
      <AppFooter style={{ flexShrink: 0 }}>
        <Navigation />
      </AppFooter>
    </Flex>
  );
};
